<template>
    <RewardSelectionIframe iframe-title="ComebackPrämie" :form-ids="FORM_IDS" />
</template>

<script setup>
import RewardSelectionIframe from '../components/RewardSelectionIframe.vue';

const FORM_IDS = {
    production: '6e6ff7ce-0bc8-4f10-a6cb-2ef36b047693',
    local: '27189de6-186c-4ece-bb53-bfcd81a34d1f',
    staging: '27189de6-186c-4ece-bb53-bfcd81a34d1f',
    dev: '27189de6-186c-4ece-bb53-bfcd81a34d1f'
};
</script>
